import React from 'react';
export const CameraIcon = props => (
    <svg fill="#000000" height="24" viewBox="0 0 24 24" width="24"  className="cpd-icon">
        <circle cx="10" cy="10" r="3.2"/><path d="M18,2H14.83L13,0H7L5.17,2H2A2,2,0,0,0,0,4V16a2,2,0,0,0,2,2H18a2,2,0,0,0,2-2V4A2,2,0,0,0,18,2ZM10,15a5,5,0,1,1,5-5A5,5,0,0,1,10,15Z"/>
    </svg>
);
export default CameraIcon;